export default {
  translation: {
    common: {
      accept: 'Accept',
      alreadyUser: 'Already a user?',
      and: 'and',
      backToLogin: 'Back to login page',
      coreNotFound: 'Failed to fetch core settings',
      createAccount: 'Create an account',
      createYourAccount: 'Create your account',
      emailOrUsername: 'Email or username',
      invalidUsernameOrPassword: 'Invalid username or password',
      localRegistrationDisabled: 'User local registration is disabled by the administrator',
      login: 'Login',
      logInToBoards: 'Log in',
      loginWithGoogle: 'Login with Google',
      newToBoards: 'New to 4ga Boards?',
      noInternetConnection: 'No internet connection',
      pageNotFound_title: 'Page Not Found',
      password: 'Password',
      policyNotAccepted: 'Please accept Terms of Service and Privacy Policy',
      privacyPolicy: 'Privacy Policy',
      register: 'Register',
      registerWithGoogle: 'Register with Google',
      registrationDisabled: 'All user registration is disabled by the administrator',
      serverConnectionFailed: 'Server connection failed',
      ssoRegistrationDisabled: 'User SSO registration is disabled by the administrator',
      termsOfService: 'Terms of Service',
      togglePasswordVisibility: 'Toggle password visibility',
      unknownError: 'Unknown error, try again later',
    },

    action: {
      logIn: 'Log in',
    },
  },
};
